<template>
  <div class="store">
    <h3>{{TLang('适用门店','my')}}</h3>

    <div class="store-list">
      <div class="area-list clear" ref="wrap">
        <ul class="clear fl" ref="areaList">
          <li
            class="fl"
            :class="{ active: !currentCity.id }"
            @click="currentCity = {}; hasMoreStore = false;"
          >
            {{TLang('全部','my')}}
            <span v-if="!currentCity.id">({{ salesroomsList.length }})</span>
          </li>
          <li
            class="fl"
            :class="{ active: currentCity.id === item.id }"
            v-for="item in regions"
            :key="item.id"
            @click="currentCity = item; hasMoreStore = false;"
          >
            {{ item.name }}
            <span v-if="currentCity.id === item.id">({{ salesroomsList.length }})</span>
          </li>
        </ul>

        <span class="fr down-or-up" v-if="hasMore" @click="setAreaListHeight">
          {{ hasMore === 1 ? TLang('展开', 'my') : TLang('收起', 'my') }}
          <img
            :class="{ 'silde-up': hasMore === 2 }"
            :src="require('@assets/images/birthday/slide_down_icon.png')"
            alt=""
          />
        </span>
      </div>

      <div class="store-list-wrap">
        <ul>
          <li
            v-for="(item, index) in salesroomsList"
            :key="item.id"
          >
            <div class="store-info-box" v-if="index < 3 || hasMoreStore">
              <h4>{{ item.name }}</h4>
              <p>{{ TLang('地址','my') }}：{{ item.address }}</p>
              <p>{{ TLang('电话','my') }}：{{ item.telephone }}</p>
              <p>{{ TLang('营业时间','my') }}：{{ item.businessHours }}</p>
            </div>
          </li>
        </ul>

        <p
          class="get-more-store"
          v-if="salesroomsList.length > 3"
          @click="hasMoreStore = !hasMoreStore"
        >
          {{ hasMoreStore ? TLang('点击收起', 'my') : TLang('查看更多门店', 'my') }}
          <img
            :class="{ 'silde-up': hasMoreStore }"
            :src="require('@assets/images/birthday/slide_down_icon.png')"
            alt=""
          />
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "storeList",

  props: {
    regions: {
      type: Array,
      default: () => []
    },
    salesrooms: {
      type: Array,
      default: () => []
    }
  },

  computed:{
    salesroomsList(){
      const salesroomsList = this.currentCity.id ? this.salesrooms.filter(item => item.regionId === this.currentCity.id) : this.salesrooms;
      return salesroomsList;
    }
  },

  data() {
    return {
      hasMore: 0, // 0 不显示展开收起  1 展开  2 收起
      hasMoreStore: false,
      currentCity: {}
    };
  },
  
  mounted() {
    this.isHasMoreArea();
  },

  methods: {
    // 地区是否显示展开收起
    isHasMoreArea() {
      const { areaList, wrap } = this.$refs;
      const listHeight = areaList.offsetHeight;
      const itemHeight = areaList.children[0].offsetHeight + 12;
      this.hasMore = listHeight > itemHeight ? 1 : 0;
      wrap.style.height = `${itemHeight}px`;
    },

    // 点击地区展开收起
    setAreaListHeight() {
      const { areaList, wrap } = this.$refs;
      const listHeight = areaList.offsetHeight;
      const itemHeight = areaList.children[0].offsetHeight + 12;
      wrap.style.height =
        this.hasMore === 1 ? `${listHeight}px` : `${itemHeight}px`;
      this.hasMore = this.hasMore === 1 ? 2 : 1;
    }
  }
};
</script>

<style lang="less" scoped>
.store {
  margin-bottom: 35px;
  h3 {
    color: #2351a2;
    font-size: 20px;
    margin-bottom: 30px;
    line-height: 1;
  }
  .store-list {
    border: 1px solid #ececec;
  }
  .area-list {
    background: #ededed;
    font-size: 14px;
    padding: 16px 20px 3px 20px;
    transition: all 0.2s ease-in;
    overflow: hidden;
    ul {
      width: 1010px;
    }
    li {
      color: #666;
      margin: 0 15px 12px;
      line-height: 24px;
      padding: 0 7px;
      cursor: pointer;
      &.active {
        color: #fff;
        background: #619ee0;
        &:hover {
          color: #fff;
          background: #619ee0;
        }
      }
      &:hover {
        color: #619ee0;
      }
    }
  }
  .down-or-up {
    color: #999;
    cursor: pointer;
    &:hover {
      opacity: 0.6;
    }
    img {
      width: 13px;
      height: 8px;
      vertical-align: middle;
      transition: all 0.2s ease-in;
      &.silde-up {
        transform: rotate(180deg);
      }
    }
  }
  .store-list-wrap {
    .store-info-box {
      padding: 15px 25px;
      border-bottom: 1px dashed #ececec;
      font-size: 14px;
      line-height: 24px;
      h4 {
        color: #282828;
        margin-bottom: 5px;
      }
      p {
        color: #a3a3a3;
        padding-left: 25px;
      }
      &:last-child {
        border-bottom: 1px solid #fff;
      }
    }
  }
  .get-more-store {
    margin-left: 50px;
    margin-bottom: 35px;
    font-size: 14px;
    color: #1c4a9c;
    cursor: pointer;
    &:hover {
      opacity: 0.6;
    }
    img {
      width: 13px;
      height: 8px;
      vertical-align: middle;
      &.silde-up {
        transform: rotate(180deg);
      }
    }
  }
}
</style>
